import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const ExpenseInput = () => {
  const { expenseId = '' } = useParams();
  const decodedId = expenseId ? atob(expenseId) : expenseId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [categories, setCategories] = useState([]);
  const route = 'expense';

  useEffect(() => {
    if (expenseId) {
      setIsEditing(true);
      fetchExpenseDetails();
    }
    fetchExistingAccounts();
    fetchPaymentMethods();

  }, [expenseId]);

  const fetchExpenseDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.expense}${id}/`, { headers });
      const expenseDetails = response.data;

      setFormData(expenseDetails);
    } catch (error) {
      console.error('Error fetching expense details:', error);
    }
  };

  const fetchExistingAccounts = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.account}`, { headers });
      const existingAccounts = response.data.map((account) => ({
        value: account.id,
        label: account.name,
      }));

      setAccounts(existingAccounts);
      return existingAccounts;
    } catch (error) {
      console.error('Error fetching existing accounts:', error);
      return [];
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.paymentMethod}`, { headers });
      const paymentMethodsData = response.data.map((paymentMethod) => ({
        value: paymentMethod.id,
        label: paymentMethod.name,
      }));

      setPaymentMethods(paymentMethodsData);
      return paymentMethodsData;
    } catch (error) {
      console.error('Error fetching payment methods:', error);
      return [];
    }
  };



  const expenseFields = [
    {
      name: 'date',
      label: 'Date',
      type: 'date',
    },
    {
        name: 'category',
        label: 'Category',
        type: 'select',
        options: [
        { label: "Rent", value: "RENT" },
        { label: "Utilities", value: "UTILITIES" },
        { label: "Salary", value: "SALARY" },
        { label: "Marketing", value: "MARKETING" },
        { label: "Other", value: "OTHER" },
        ],
    },
    {
      name: 'amount',
      label: 'Amount',
      type: 'number',
    },
    {
      name: 'description',
      label: 'Description',
      type: 'text',
    },
    {
      name: 'paid_from',
      label: 'Paid From',
      type: 'select',
      options: accounts,
    },
   {
        name: 'payment_method',
        label: 'Payment Method',
        type: 'select',
        options: [
            { label: "Cash", value: "CASH" },
            { label: "Bank Transfer", value: "BANK_TRANSFER" }
        ],
    }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Expense' : 'Create Expense'}</h1>
      <FormComponent fields={expenseFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default ExpenseInput;